<template>
  <div class="guideline-documents">
    <div class="page-header">
      <div class="header-content">
        <a-breadcrumb class="custom-breadcrumb">
          <a-breadcrumb-item
            ><router-link to="/mobile-cms/guidelines"
              >Sumber Guidelines</router-link
            ></a-breadcrumb-item
          >
          <a-breadcrumb-item>{{ source?.name || '...' }}</a-breadcrumb-item>
        </a-breadcrumb>
        <h1>{{ source?.name }}</h1>
      </div>
    </div>

    <div class="content-container">
      <div class="tab-section">
        <a-tabs v-model:activeKey="activeTab" class="custom-tabs">
          <a-tab-pane key="interactive" tab="Interaktif" />
          <a-tab-pane key="pdf" tab="File PDF" />
        </a-tabs>
      </div>

      <div class="search-and-action">
        <a-row :gutter="16">
          <a-col :xs="24" :sm="16" :md="20">
            <a-input
              v-model:value="searchQuery"
              :placeholder="
                `Cari nama guideline ${activeTab === 'interactive' ? 'interaktif' : 'pdf'}`
              "
              class="custom-search"
              @pressEnter="handleSearch"
              size="large"
              allow-clear
            >
              <template #prefix>
                <SearchOutlined style="color: rgba(0, 0, 0, 0.25); margin-right: 4px" />
              </template>
            </a-input>
          </a-col>
          <a-col :xs="24" :sm="8" :md="4">
            <button class="tambah-button" @click="showCreateModal"><plus-outlined /> TAMBAH</button>
          </a-col>
        </a-row>
      </div>

      <div class="table-card">
        <a-table
          :columns="columns"
          :data-source="filteredGuidelines"
          :loading="loading"
          :pagination="pagination"
          @change="handleTableChange"
          row-key="id"
          class="custom-table"
          :custom-row="customRow"
        >
          <template #no="{ index }">
            {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
          </template>

          <template #name="{ record }">
            <a
              v-if="activeTab === 'interactive'"
              @click="goToStructure(record)"
              class="document-link"
            >
              {{ record.title }}
            </a>
            <a
              v-else-if="record.files && record.files.length"
              @click="viewPdf(record)"
              class="document-link"
            >
              {{ record.title }}
            </a>
            <span v-else>{{ record.title }}</span>
          </template>

          <template #date="{ record }">
            {{ formatDate(record.upload_date) }}
          </template>

          <template #file="{ record }">
            <a v-if="record.files && record.files.length" @click="viewPdf(record)" class="pdf-link">
              {{ getPrimaryFile(record).title }}
            </a>
            <span v-else>-</span>
          </template>

          <template #action="{ record }">
            <div class="action-buttons">
              <button class="btn-action-pill edit-btn" @click="showEditModal(record)">
                <edit-outlined /> UBAH
              </button>

              <button class="btn-action-pill delete-btn" @click="confirmDelete(record)">
                <delete-outlined /> HAPUS
              </button>
            </div>
          </template>
        </a-table>
      </div>
    </div>

    <!-- Create/Edit Modal -->
    <a-modal
      :title="modalTitle"
      v-model:visible="modalVisible"
      :confirm-loading="modalLoading"
      @cancel="handleModalCancel"
      :width="700"
      class="premium-modal"
      :footer="null"
    >
      <a-form :model="form" layout="vertical" ref="formRef" class="custom-form">
        <a-form-item
          name="title"
          :rules="[{ required: true, message: 'Nama guideline wajib diisi' }]"
        >
          <template #label>
            <span>Nama Guideline <span style="color: #ff4d4f">*</span></span>
          </template>
          <a-input v-model:value="form.title" placeholder="Masukkan nama guideline" size="large" />
        </a-form-item>

        <a-form-item
          v-if="activeTab === 'pdf'"
          name="date"
          :rules="[{ required: true, message: 'Waktu diunggah wajib diisi' }]"
        >
          <template #label>
            <span>Waktu Diunggah <span style="color: #ff4d4f">*</span></span>
          </template>
          <a-date-picker v-model:value="form.date" style="width: 100%" size="large" />
        </a-form-item>

        <a-form-item
          v-if="activeTab === 'pdf'"
          name="file"
          :rules="[{ required: !editingGuideline, message: 'File PDF wajib diupload' }]"
        >
          <template #label>
            <span>File PDF Guideline <span style="color: #ff4d4f">*</span></span>
          </template>
          <a-upload
            :before-upload="onBeforeUpload"
            :file-list="fileList"
            :multiple="false"
            :max-count="1"
            accept=".pdf"
            @change="onUploadChange"
            @remove="onUploadRemove"
          >
            <button type="button" class="btn-upload-outline"><upload-outlined /> UNGGAH</button>
          </a-upload>
          <div
            v-if="editingGuideline && getPrimaryFile(editingGuideline) && !form.file"
            class="mt-2"
            style="color: #6b7280; font-size: 13px"
          >
            File saat ini: <strong>{{ getPrimaryFile(editingGuideline).title }}</strong
            >. Upload baru akan mengganti file lama.
          </div>
        </a-form-item>

        <a-form-item class="mb-0 mt-8">
          <div class="d-flex justify-center modal-action-buttons">
            <button
              type="button"
              class="confirm-button"
              :disabled="modalLoading"
              @click="handleModalOk"
            >
              <span v-if="modalLoading" class="button-spinner"></span>
              {{ modalLoading ? 'MENYIMPAN...' : 'SIMPAN' }}
            </button>
            <button type="button" class="cancel-button" @click="handleModalCancel">KEMBALI</button>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model:visible="confirmModalVisible"
      :title="confirmModalTitle"
      :footer="null"
      :closable="true"
      @cancel="confirmModalVisible = false"
      :width="450"
      :z-index="9999"
      class="premium-confirmation-modal"
    >
      <div class="confirm-content text-center">
        <p class="confirm-description">{{ confirmModalDescription }}</p>
        <div class="confirm-footer d-flex confirm-modal-action-buttons mt-8">
          <button class="btn-footer btn-confirm-cancel" @click="confirmModalVisible = false">
            KEMBALI
          </button>
          <button
            class="btn-footer btn-confirm-ok"
            :class="{ 'btn-danger': confirmModalType === 'delete' }"
            @click="handleConfirmOk"
          >
            {{ confirmModalOkText }}
          </button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, watch, h } from 'vue'
import { notification } from 'ant-design-vue'
import { CheckCircleOutlined } from '@ant-design/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import moment from 'moment'
import 'moment/locale/id'
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
} from '@ant-design/icons-vue'
import { mobileCmsGuidelineAPI } from '@/services/axios/perki/mobileCms'

export default {
  name: 'MobileCmsGuidelineDocuments',
  components: {
    EditOutlined,
    DeleteOutlined,
    PlusOutlined,
    SearchOutlined,
    UploadOutlined,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const sourceId = route.params.sourceId

    const source = ref(null)
    const activeTab = ref('interactive')
    const loading = ref(false)
    const guidelines = ref([])
    const searchQuery = ref('')
    const modalVisible = ref(false)
    const modalLoading = ref(false)
    const editingGuideline = ref(null)
    const formRef = ref(null)

    const form = reactive({
      title: '',
      date: moment(),
      file: null,
    })
    const fileList = ref([])

    // Confirmation Modal State
    const confirmModalVisible = ref(false)
    const confirmModalType = ref('') // 'save', 'edit', 'delete'
    const confirmModalTarget = ref(null)

    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
      showSizeChanger: true,
      showTotal: total =>
        `Menampilkan ${(pagination.value.current - 1) * pagination.value.pageSize +
          1} sampai ${Math.min(
          pagination.value.current * pagination.value.pageSize,
          total,
        )} dari ${total} baris`,
    })

    const columns = computed(() => {
      const base = [
        { title: 'No.', key: 'no', slots: { customRender: 'no' } },
        {
          title: 'Nama Guideline',
          dataIndex: 'title',
          key: 'title',
          slots: { customRender: 'name' },
          sorter: true,
        },
      ]

      if (activeTab.value === 'pdf') {
        base.push(
          {
            title: 'Waktu Diunggah',
            dataIndex: 'upload_date',
            key: 'upload_date',
            slots: { customRender: 'date' },
            sorter: true,
          },
          { title: 'File Guideline', key: 'file', slots: { customRender: 'file' } },
        )
      }

      base.push({ title: 'Aksi', key: 'action', slots: { customRender: 'action' }, align: 'right' })
      return base
    })

    const filteredGuidelines = computed(() => {
      // In a real app, the API would return separate lists or have a filter param
      // For now, if we use the same entity, we might need a way to distinguish them
      // Let's assume all guidelines we fetch here are of the activeTab type for demo logic
      return guidelines.value
    })

    const modalTitle = computed(() => {
      const type = activeTab.value === 'interactive' ? 'Interaktif' : 'File PDF'
      return `${editingGuideline.value ? 'Ubah' : 'Tambah'} Guideline - ${type}`
    })

    const confirmModalTitle = computed(() => {
      if (confirmModalType.value === 'delete') return 'Hapus data?'
      if (confirmModalType.value === 'edit') return 'Ubah data?'
      return 'Yakin isi formulir sudah sesuai?'
    })

    const confirmModalDescription = computed(() => {
      if (confirmModalType.value === 'delete')
        return 'Data yang dihapus tidak dapat dikembalikan. Apakah Anda yakin ingin melanjutkan?'
      if (confirmModalType.value === 'edit')
        return 'Mohon cek kembali perubahan data sebelum menyimpan formulir.'
      return 'Mohon cek kembali data sebelum menyimpan formulir.'
    })

    const confirmModalOkText = computed(() => {
      if (confirmModalType.value === 'delete') return 'YA, HAPUS'
      return 'YA, SIMPAN'
    })

    const showSuccessNotification = msg => {
      notification.success({
        message: 'Success',
        description: msg,
        placement: 'topRight',
        // icon: () => h(CheckCircleOutlined, { style: 'color: #10b981' }),
        class: 'premium-notification',
        duration: 3,
      })
    }

    const normalizeGuideline = record => ({
      ...record,
      files: Array.isArray(record?.files) && record.files.length ? [record.files[0]] : [],
    })

    const getPrimaryFile = record => {
      if (!record || !Array.isArray(record.files) || !record.files.length) return null
      return record.files[0]
    }

    const resetModalForm = () => {
      form.title = ''
      form.date = moment()
      form.file = null
      fileList.value = []
    }

    const loadSource = async () => {
      try {
        const res = await mobileCmsGuidelineAPI.getSources({ id: sourceId })
        source.value = res.data.data.find(s => s.id === sourceId)
      } catch (err) {
        console.error('Failed to load source', err)
      }
    }

    const loadGuidelines = async () => {
      loading.value = true
      try {
        const params = {
          source_id: sourceId,
          type: activeTab.value,
          page: pagination.value.current,
          page_size: pagination.value.pageSize,
        }
        if (searchQuery.value) params.search = searchQuery.value
        if (pagination.value.sortBy) params.sort_by = pagination.value.sortBy
        if (pagination.value.sortOrder) params.sort_order = pagination.value.sortOrder

        const response = await mobileCmsGuidelineAPI.getAll(params)
        guidelines.value = Array.isArray(response.data.data)
          ? response.data.data.map(normalizeGuideline)
          : []
        pagination.value.total = response.data.pagination.total
      } catch (error) {
        console.error('Load guidelines failed', error)
      } finally {
        loading.value = false
      }
    }

    const handleTableChange = (pag, filters, sorter) => {
      pagination.value.current = pag.current
      pagination.value.pageSize = pag.pageSize

      // Handle Sorting
      if (sorter.field && sorter.order) {
        pagination.value.sortBy = sorter.field
        pagination.value.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
      } else {
        pagination.value.sortBy = null
        pagination.value.sortOrder = null
      }

      loadGuidelines()
    }
    const customRow = record => {
      return {
        onClick: event => {
          // Prevent navigation when clicking on recursive interactive elements
          const target = event.target
          if (
            target.tagName !== 'BUTTON' &&
            target.tagName !== 'A' &&
            target.tagName !== 'INPUT' &&
            !target.closest('button') &&
            !target.closest('.ant-switch') &&
            !target.closest('.action-buttons')
          ) {
            if (activeTab.value === 'interactive') {
              goToStructure(record)
            } else {
              viewPdf(record)
            }
          }
        },
      }
    }

    const handleSearch = () => {
      pagination.value.current = 1
      loadGuidelines()
    }

    const showCreateModal = () => {
      editingGuideline.value = null
      resetModalForm()
      modalVisible.value = true
    }

    const showEditModal = record => {
      const normalizedRecord = normalizeGuideline(record)
      editingGuideline.value = normalizedRecord
      form.title = normalizedRecord.title
      form.date = normalizedRecord.upload_date ? moment(normalizedRecord.upload_date) : moment()
      form.file = null
      fileList.value = []
      modalVisible.value = true
    }

    const handleModalOk = async () => {
      try {
        await formRef.value.validate()
        confirmModalType.value = editingGuideline.value ? 'edit' : 'save'
        confirmModalVisible.value = true
      } catch {
        return
      }
    }

    const handleConfirmOk = async () => {
      const type = confirmModalType.value
      confirmModalVisible.value = false

      if (type === 'delete') {
        await deleteGuideline(confirmModalTarget.value)
        return
      }

      modalLoading.value = true
      try {
        const formData = new FormData()
        formData.append('source_id', sourceId)
        formData.append('type', activeTab.value)
        formData.append('title', form.title)
        formData.append('upload_date', form.date.toISOString())
        if (form.file) formData.append('file', form.file)

        if (editingGuideline.value) {
          await mobileCmsGuidelineAPI.update(editingGuideline.value.id, formData)
          showSuccessNotification('Guideline berhasil diubah.')
        } else {
          await mobileCmsGuidelineAPI.create(formData)
          showSuccessNotification('Guideline berhasil ditambahkan.')
        }
        modalVisible.value = false
        loadGuidelines()
      } catch (error) {
        notification.error({ message: 'Error', description: 'Gagal menyimpan guideline.' })
      } finally {
        modalLoading.value = false
      }
    }

    const confirmDelete = record => {
      confirmModalTarget.value = record
      confirmModalType.value = 'delete'
      confirmModalVisible.value = true
    }

    const deleteGuideline = async record => {
      try {
        await mobileCmsGuidelineAPI.delete(record.id)
        showSuccessNotification('Guideline berhasil dihapus.')
        loadGuidelines()
      } catch (error) {
        notification.error({ message: 'Error', description: 'Gagal menghapus guideline.' })
      }
    }

    const goToStructure = record => {
      router.push(`/mobile-cms/guidelines/structure/${record.id}`)
    }

    const viewPdf = record => {
      const file = getPrimaryFile(record)
      if (file) {
        let url = file.file_url
        if (!url.startsWith('http')) {
          const baseUrl = (
            process.env.VUE_APP_PERKI_API_URL || 'http://localhost:3000/api/v1'
          ).replace('/api/v1', '')
          url = `${baseUrl}${url}`
        }
        window.open(url, '_blank')
      }
    }

    const formatDate = date => {
      if (!date) return '-'
      moment.locale('id')
      return moment(date).format('DD MMMM YYYY')
    }

    const onBeforeUpload = file => {
      form.file = file
      fileList.value = [file]
      return false
    }

    const onUploadChange = ({ file, fileList: nextFileList }) => {
      const latestFile = nextFileList.length ? nextFileList[nextFileList.length - 1] : file

      if (!latestFile) {
        form.file = null
        fileList.value = []
        return
      }

      form.file = latestFile.originFileObj || latestFile
      fileList.value = [latestFile]
    }

    const onUploadRemove = () => {
      form.file = null
      fileList.value = []
      return false
    }

    const handleModalCancel = () => {
      editingGuideline.value = null
      resetModalForm()
      modalVisible.value = false
      return false
    }

    onMounted(() => {
      loadSource()
      loadGuidelines()
    })

    watch(activeTab, () => {
      pagination.value.current = 1
      searchQuery.value = ''
      pagination.value.sortBy = null
      pagination.value.sortOrder = null
      loadGuidelines()
    })

    watch(searchQuery, val => {
      if (!val) {
        pagination.value.current = 1
        loadGuidelines()
      }
    })

    return {
      source,
      activeTab,
      loading,
      filteredGuidelines,
      searchQuery,
      pagination,
      columns,
      modalVisible,
      modalLoading,
      editingGuideline,
      form,
      formRef,
      modalTitle,
      fileList,
      getPrimaryFile,
      handleSearch,
      handleTableChange,
      showCreateModal,
      showEditModal,
      handleModalOk,
      handleConfirmOk,
      handleModalCancel,
      confirmDelete,
      deleteGuideline,
      goToStructure,
      formatDate,
      onBeforeUpload,
      onUploadChange,
      onUploadRemove,
      loadGuidelines,
      viewPdf,
      customRow,
      confirmModalVisible,
      confirmModalTitle,
      confirmModalDescription,
      confirmModalOkText,
      confirmModalType,
    }
  },
}
</script>

<style lang="scss">
/* Global overrides for teleported modal content */
.premium-modal .ant-modal-title {
  font-size: 20px;
  font-weight: 700 !important;
  color: #111827;
}

.premium-confirmation-modal .ant-modal-title {
  font-size: 20px;
  font-weight: 700 !important;
  color: #111827;
}

.ant-modal-header {
  border-bottom: none !important;
  text-align: left;
  padding: 24px 24px 0px 24px !important;
}
</style>

<style lang="scss" scoped>
@import '../../styleViews.scss';

.guideline-documents {
  background: #fcfcfc;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 4px;
  }
}

.custom-breadcrumb {
  margin-bottom: 8px;
  font-size: 14px;
}

.page-header h1 {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.content-container {
  border-radius: 12px;
  margin-top: 24px;
  overflow: hidden;
}

:deep(.ant-tabs-nav .ant-tabs-tab:hover) {
  color: #e10f28 !important;
}

.custom-tabs :deep(.ant-tabs-nav) {
  margin-bottom: 0;
}

.custom-tabs :deep(.ant-tabs-tab) {
  padding: 16px 0;
  font-size: 15px;
}

.custom-tabs :deep(.ant-tabs-tab-active) {
  color: #dc2626;
}

.custom-tabs :deep(.ant-tabs-ink-bar) {
  background: #dc2626;
  height: 3px;
}

.search-and-action {
  margin: 8px 0px 24px 0px;
}

.custom-search :deep(.ant-input::placeholder) {
  color: #999999 !important;
  opacity: 1 !important;
  font-size: 14px;
}

.document-link {
  color: #444444;
  font-weight: 400;

  &:hover {
    color: #dc2626;
  }
}

.pdf-link {
  color: #dc2626;
  text-decoration: underline;
  font-size: 13px;
}

.tambah-button {
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  border: 2px solid #e10f28;
  width: 100%;
  background: #e10f28;
  color: white;
  padding: 6px 12px;
  transition: all 0.3s;
  font-family: 'Barlow', sans-serif !important;

  @media (max-width: 576px) {
    margin-top: 12px;
  }

  &:hover {
    background: white !important;
    border-color: #e10f28 !important;
    color: #e10f28 !important;
  }
}

.table-card {
  overflow: hidden;
}

/* Table Aesthetics */
::v-deep(.ant-table-thead > tr > th) {
  background: #f2f4f8 !important;
  font-weight: 600;
  color: #262626;
  padding: 16px 24px;
  border-right: none !important;
  border-bottom: 1px solid #e5e7eb;
}

::v-deep(.ant-table) {
  border-collapse: collapse;
  font-size: 14px;
}

::v-deep(.ant-table-tbody > tr) {
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
}

::v-deep(.ant-table-bordered .ant-table-body > table) {
  border: none !important;
}

::v-deep(.ant-table-tbody > tr > td) {
  padding: 16px 24px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none !important;
  background: white !important;
}

::v-deep(.ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td) {
  background: #e4e9f0 !important;
}

::v-deep(.ant-table-tbody > tr > td.ant-table-column-sort) {
  background: white !important;
}

/* Pagination Styling */
:deep(.ant-pagination) {
  padding: 16px 24px;
  margin: 0 !important;
  border-top: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

:deep(.ant-pagination-total-text) {
  color: #6b7280;
  flex: 1;
  text-align: left;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.btn-action-pill {
  height: 32px;
  padding: 0 16px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  background: white;
  transition: all 0.2s;
}

.edit-btn {
  border: 2px solid var(--E-Office-Secondary, #282828);
  color: #282828;

  &:hover {
    border-color: #9ca3af;
    background: #f9fafb;
  }
}

.delete-btn {
  background: #1f2937;
  border: 1px solid #1f2937;
  color: white;

  &:hover {
    background: #374151;
    border-color: #374151;
  }
}

/* Modal form overrides */
.premium-modal {
  position: relative;
}

.premium-modal :deep(.ant-modal-close-x) {
  font-size: 18px;
}

.custom-form :deep(.ant-form-item) {
  margin-bottom: 24px;
}

.custom-form :deep(label.ant-form-item-required) {
  margin-bottom: 0 !important;
  font-weight: 600;
}

.custom-form :deep(.ant-form-item-label > label) {
  font-weight: 600;
  color: #374151;
}

.custom-form :deep(.ant-form-item-label > label::after),
.custom-form :deep(.ant-form-item-label > label.ant-form-item-required::before),
.custom-form :deep(.ant-form-item-label > label.ant-form-item-required::after) {
  display: none !important;
  content: none !important;
}

.premium-modal :deep(.ant-input) {
  border-radius: 8px;
  border-color: #d1d5db;
  font-size: 14px;
}

:deep(.ant-input::placeholder) {
  color: #798892 !important;
  opacity: 1 !important;
}

.btn-upload-outline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border-radius: 20px;
  border: 2px solid #dc2626;
  background: white;
  color: #dc2626;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #fef2f2;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.cancel-button {
  max-width: 230px;
  background: #ffffff;
  border: 2px solid #1a1a1a;
  color: #1a1a1a;
  border-radius: 50px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Barlow' !important;
  cursor: pointer;
  transition: all 0.3s;
  height: 40px;

  &:hover {
    background: #1a1a1a;
    color: white;
  }
}

.confirm-button {
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  border: 2px solid #e10f28;
  max-width: 150px;
  background: #e10f28;
  color: white;
  padding: 6px 16px;
  transition: all 0.3s;
  height: 40px;
  line-height: 1.5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: 'Barlow' !important;

  @media (max-width: 768px) {
    width: 100%;
  }

  &:hover:not(:disabled) {
    background: white;
    border-color: #e10f28;
    color: #e10f28;
  }

  &:disabled {
    border-color: #98a2b3;
    background: #98a2b3;
    color: white;
    cursor: not-allowed;
    opacity: 0.8;
  }

  .button-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid #ffffff;
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
}

.premium-confirmation-modal :deep(.ant-modal-content) {
  border-radius: 16px;
  padding: 12px;
}

.premium-confirmation-modal :deep(.ant-modal-header) {
  border-bottom: none;
  text-align: left;
  padding: 24px 24px 0 24px;
}

.premium-confirmation-modal :deep(.ant-modal-title) {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
}

.confirm-description {
  font-size: 16px;
  color: #4b5563;
  text-align: left;
  margin-bottom: 28px;
}

.confirm-modal-action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.btn-confirm-cancel {
  padding: 8px 20px;
  border-radius: 24px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;

  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid #111827;
  color: #111827;
  // width: 100%; // removing this to match sources.vue

  &:hover {
    background: #111827;
    border: 1px solid #111827;
    color: white;
  }
}

.btn-confirm-ok {
  padding: 8px 20px;
  border-radius: 24px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;

  align-items: center;
  justify-content: center;
  background: #dc2626;
  color: white;
  border: 1px solid $primary;
  // width: 100%; // removing this to match sources.vue

  &:hover {
    background: transparent;
    color: $primary;
    border: 1px solid $primary;
  }
}

/* Notification Styling */
:deep(.premium-notification) {
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);

  .ant-notification-notice-message {
    font-weight: 700;
    margin-bottom: 4px;
  }

  .ant-notification-notice-description {
    font-size: 14px;
    color: #4b5563;
  }

  .ant-notification-notice-close {
    top: 16px;
    right: 16px;
  }
}
</style>
